<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>
      <!-- {{data.intro}} -->
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <!-- <div class="row justify-content-between product">
            <div class="row py-3 gap-3"> -->
          <div class="row">
            <div class="col-12 row align-items-start">
              <div class="col-11 row justify-content-center">
                <div class="row" v-for="(item, index) in data" :key="index">
                  <!-- AR Data -->
                  <h5>السؤال رقم {{ index + 1 }}</h5>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        @keypress="isArabic"
                        v-model.trim="item.question_ar"
                      />
                      <label for="name_input" class="form-label"
                        >السؤال (عربي)</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        @keypress="isEnglish"
                        v-model.trim="item.question_en"
                      />
                      <label for="name_input" class="form-label"
                        >السؤال (انجليزي)</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <label for="name_input" class="form-label"
                        >الاجابة (عربي)</label
                      >
                      <textarea
                        class="form-control"
                        rows="4"
                        @keypress="isArabic"
                        v-model="item.answer_ar"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <label for="name_input" class="form-label"
                        >الاجابة (انجليزي)</label
                      >
                      <textarea
                        class="form-control"
                        rows="4"
                        @keypress="isEnglish"
                        v-model="item.answer_en"
                      ></textarea>
                    </div>
                  </div>
                  <hr
                    role="separator"
                    aria-orientation="horizontal"
                    class="v-divider theme--dark col-12 my-10"
                  />
                </div>
              </div>
              <!-- Actions -->
              <div class="col-lg-1 row">
                <div class="col-6 py-0" v-if="data.length > 0">
                  <span class="append" @click="appendGeneralFeature()">
                    <i class="fas fa-plus-circle"></i>
                  </span>
                </div>
                <div class="col-6 py-0" v-show="data.length > 1">
                  <span class="append" @click="deleteGeneralFeature()">
                    <i class="fas fa-minus-circle"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="name_input" class="form-label"> الخدمة </label>
                <multiselect
                  v-model="service_id"
                  :options="services"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                >
                  <template slot="option" slot-scope="props">
                    <!-- <img class="option__image" :src="props.option.image" /> -->
                    <div class="option__desc d-flex justify-between">
                      <span class="option__title">
                        {{ props.option.name }}
                      </span>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
          <!-- </div>
          </div> -->
        </div>
        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.faqs.title"),
          disabled: false,
          href: "/faqs",
        },
        {
          text: this.$t("breadcrumb.faqs.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,
      data: [
        {
          question_ar: null,
          question_en: null,
          answer_ar: null,
          answer_en: null,
        },
      ],
      service_id: null,
      services: [],
    };
  },

  computed: {},

  methods: {
    // Upload
    // General Features Append And Delete
    appendGeneralFeature() {
      this.data.push({
        question_ar: null,
        question_en: null,
        answer_ar: null,
        answer_en: null,
      });
    },
    deleteGeneralFeature() {
      this.data.splice(-1);
    },

    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      this.submitData();
      // return;
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append(`service_id`, this.service_id.id);
      this.data.forEach((item, index) => {
        submit_data.append(`faqs[${index}][ar][question]`, item.question_ar);
        submit_data.append(`faqs[${index}][en][question]`, item.question_en);
        submit_data.append(`faqs[${index}][ar][answer]`, item.answer_ar);
        submit_data.append(`faqs[${index}][en][answer]`, item.answer_en);
      });

      this.axios({
        method: "POST",
        url: "faqs",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/faqs" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    getData() {
      this.axios({
        method: "GEt",
        url: "faqs",
      })
        .then((res) => {
          this.data = res.data.data;
          this.btnIsLoading = false;
        })
        .catch(() => {
          // this.$iziToast.error({
          //   timeout: 2000,
          //   message: err.response.data.message,
          //   position: "bottomRight",
          // });
          this.btnIsLoading = false;
        });
    },
    getServices() {
      this.axios({
        method: "GET",
        url: `service`,
      })
        .then((res) => {
          this.services = res.data.data;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  mounted() {
    // this.getData();
    this.getServices();
  },
};
</script>

<style lang="scss" scoped>
.product {
  .chooseImage {
    width: auto !important;
  }
}
.solution_forms_radio_inputs {
  span {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid var(--mainColor-2_2);
    display: inline-block;
  }
  .solution_form {
    label {
      padding: 8px 15px;
      font-size: 14px;
      color: var(--light_gray_clr);
      border-radius: 6px;
      background: var(--white_clr);
      border: 2px solid transparent;
      cursor: pointer;
      position: relative;
      width: 100%;
      &::before {
        content: "";
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid var(--mainColor-2_2);
        display: inline-block;
        inset: 0;
        position: absolute;
      }
      &::after {
        content: "";
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #fff;
        display: inline-block;
        inset: 5px;
        position: absolute;
      }
    }
    input {
      display: none;
      &:checked + label::after {
        background: var(--mainColor-2_2);
      }
    }
    .solution_image {
      width: 96%;
      display: inline-block;
      max-height: 300px;
      object-fit: cover;
      border-radius: 15px;
    }
  }
}
.border_main_color {
  border: 1px solid var(--mainColor-2_2);
  padding-block: 30px;
  border-radius: 15px;
  margin-block: 15px;
  h3 {
    margin-block-end: 10px;
  }
  .solution_image {
    width: 96%;
    display: inline-block;
    max-height: 300px;
    object-fit: cover;
    border-radius: 15px;
  }
}
.productDetails {
  border: 1px solid #339989;
  border-radius: 15px;
  padding-block: 20px;

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
